module.exports = __webpack_public_path__ + "img/57000.d6f7006d.jpg";